import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import axios from 'axios';
import deepMerge from 'lodash.merge';
import FHIRService from './FHIRService';
import ProfileManager from '../managers/ProfileManager';

var BaseResourceService = /*#__PURE__*/function () {
  function BaseResourceService(resourceType) {
    _classCallCheck(this, BaseResourceService);

    var fhirPatientId = ProfileManager.activePatientId;

    if (!fhirPatientId) {
      throw new Error('Invalid patient id');
    }

    this.fhirService = new FHIRService(resourceType);
    this.patientId = fhirPatientId;
    this.nextDataUrl = null;
  }

  _createClass(BaseResourceService, [{
    key: "fetchData",
    value: function () {
      var _fetchData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var _yield$this$fhirServi, bundle, nextLink;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fhirService.search(params);

              case 2:
                _yield$this$fhirServi = _context.sent;
                bundle = _yield$this$fhirServi.data;

                if (!(!bundle || !bundle.entry)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", []);

              case 6:
                // Cache url to retrieve next records, if exists
                nextLink = bundle.link && bundle.link.length && bundle.link.find(function (l) {
                  return l && l.relation === 'next';
                });
                this.nextDataUrl = nextLink && nextLink.url;
                return _context.abrupt("return", bundle.entry);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }()
  }, {
    key: "fetchNextData",
    value: function () {
      var _fetchNextData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var url, _yield$axios$get, bundle, nextLink;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.nextDataUrl) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", []);

              case 2:
                url = this.nextDataUrl; // Remove url to retrieve next records while retrieving

                this.nextDataUrl = null;
                _context2.next = 6;
                return axios.get(url);

              case 6:
                _yield$axios$get = _context2.sent;
                bundle = _yield$axios$get.data;

                if (!(!bundle || !bundle.entry)) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", []);

              case 10:
                // Cache url to retrieve next records, if exists
                nextLink = bundle.link && bundle.link.length && bundle.link.find(function (l) {
                  return l && l.relation === 'next';
                });
                this.nextDataUrl = nextLink && nextLink.url;
                return _context2.abrupt("return", bundle.entry);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchNextData() {
        return _fetchNextData.apply(this, arguments);
      }

      return fetchNextData;
    }()
  }, {
    key: "upsertData",
    value: function () {
      var _upsertData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resourceToUpsert) {
        var _ref, existingResource, newResourceToUpsert, _yield$this$fhirServi2, newResource;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (resourceToUpsert) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", null);

              case 2:
                _context3.t1 = !!resourceToUpsert.id;

                if (!_context3.t1) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 6;
                return this.fhirService.read(resourceToUpsert.id);

              case 6:
                _context3.t1 = _context3.sent;

              case 7:
                _context3.t0 = _context3.t1;

                if (_context3.t0) {
                  _context3.next = 10;
                  break;
                }

                _context3.t0 = {};

              case 10:
                _ref = _context3.t0;
                existingResource = _ref.data;
                newResourceToUpsert = deepMerge(existingResource || {}, resourceToUpsert);

                if (!(existingResource && existingResource.id)) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 16;
                return this.fhirService.update(resourceToUpsert.id, newResourceToUpsert);

              case 16:
                return _context3.abrupt("return", existingResource.id);

              case 17:
                _context3.next = 19;
                return this.fhirService.create(newResourceToUpsert);

              case 19:
                _yield$this$fhirServi2 = _context3.sent;
                newResource = _yield$this$fhirServi2.data;
                return _context3.abrupt("return", newResource.id);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function upsertData(_x2) {
        return _upsertData.apply(this, arguments);
      }

      return upsertData;
    }()
  }, {
    key: "removeData",
    value: function () {
      var _removeData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resourceId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.fhirService.delete(resourceId);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function removeData(_x3) {
        return _removeData.apply(this, arguments);
      }

      return removeData;
    }()
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "hasNextData",
    get: function get() {
      return !!this.nextDataUrl;
    }
  }]);

  return BaseResourceService;
}();

export { BaseResourceService as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(BaseResourceService, "BaseResourceService", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/services/BaseResourceService.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();